import { useTranslation } from 'react-i18next';
import InfoPage from '../components/InfoPage';

function Contact() {
  const { t } = useTranslation();

  return (
    <InfoPage ns="contact">
      <p className="info-extra">{t('contact.order')}</p>
    </InfoPage>
  );
}

export default Contact;
